import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.css']
})
export class StartPageComponent implements OnInit {

  constructor(private router: Router,private resolver: ResolverService) { }

  ngOnInit(): void {
  }

  isResolverLoading(){
    return this.resolver.isResolverLoading();
  }

}
